<template>
  <div>
        <a-button type="default" size="small" @click="goBack" style="margin-left:10px"><span class="ti-arrow-left"></span></a-button>
        <a-card :title="`Institution: ${institution.inst_name} of ${institution.name}`" :bordered="false" v-if="!loading">
        <a-button type="primary" size="small" slot="extra" @click="visible = true">Add new room</a-button>
        <table class="table table-sm">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Room Name</th>
              <th scope="col">Email</th>
              <th scope="col">Room type</th>
              <th scope="col">Remove</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,i) in institution.hosts" :key="i">
              <th scope="row">{{item.room_id}}</th>
               <th scope="row">{{item.room_name}}</th>
              <th scope="row">{{item.email}}</th>
              <th scope="row">{{item.type == 1 ? 'Basic':'Licensed' }}</th>
              <th scope="row"><a-popconfirm
                        title="Are you sure remove this room?"
                        ok-text="Yes"
                        cancel-text="No"
                        @confirm="RemoveHost(item.room_id)"
                        @cancel="cancel"
                    >
                        <a-button type="warning" title="Remove!" size="small">
                            <span class="ti-archive"></span>
                        </a-button>
                    </a-popconfirm></th>
            </tr>
          </tbody>
        </table>

      </a-card>
       
        <a-modal
            :footer="null"
            title="Add new room!"
            :visible="visible"
            @cancel="cancel"
            >
            <a-row>
               <a-form :form="form" @submit="handleSubmitHost">
                        <a-form-item label="">
                            <p>Application: <b>{{application.ew_app_name}}</b></p>
                             <p>Institution: <b>{{institution.name}}</b></p>
                        </a-form-item>
                        <a-form-item label="Inactive Rooms">
                            <a-select
                                v-decorator="[
                                'room_id',
                                { rules: [{ required: true, message: 'Please select room!' }] },
                                ]"
                            >
                                <a-select-option v-for="item in application.inactive_hosts" :value="item.room_id" :key="item.room_id" >
                                    {{item.room_name}}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                        
                        

                        <a-form-item >
                            <a-button type="primary" html-type="submit">
                                Submit
                            </a-button>
                        </a-form-item>
                    </a-form>
          </a-row>
        </a-modal>
  </div>
</template>

<script>
import API from '../../services/api.js'
export default {
  data(){
    return {
      inst_id: this.$route.params.insid,
      appid: this.$route.params.id,
      loading: true,
      institution:{},
      application:{},
      visible:false,
      form: this.$form.createForm(this),
    }
  },
  created() {
    this.getInstitution()
    this.getApplication()
  },
  methods:{
    goBack(){
      return this.$router.go(-1)
    },
    async getInstitution(){
      API.get(`/api/admin/institutions/${this.inst_id}`)
      .then(res => { 
        this.institution = res.data
        this.loading = false
      })
      .catch(error => console.log(error));
    
    },
    cancel(){
      this.visible = false
    },
    RemoveHost(roomid){
      API.put(`/api/admin/institution/${this.inst_id}/rooms/${roomid}`)
      .then(response => {
          this.$message.success('Remove successfully!')
          this.getInstitution()
      })
  },
    handleSubmitHost(e){
        e.preventDefault();
        this.form.validateFields((err, values) => {
            if (!err) {
                values.application_id = this.$route.params.id;
                values.institution    = this.inst_id;
                console.log(values)
                API.post(`/api/admin/institution/rooms`,values)
                .then(response => {
                  console.log(response)
                    if(response.status === 200 || response.status === 201){
                        this.$message.success('Sucessfully inserted!')
                        this.getInstitution();
                        this.form.resetFields
                        this.visible = false
                    }else{
                        this.$message.warning('This room cant be added in this institution!')
                    }
                })
            }
        });
    },
    async getApplication(){
      API.get(`/api/admin/applications/${this.appid}`)
      .then(res => { 
          this.application = res.data[0];
          this.application.inactive_hosts = this.application.hosts.filter(item => item.active == 0)
      })
      .catch(error => console.log(error));
}
  }
}
</script>

<style>

</style>